import React from 'react';
import MicroLabel from '../components/MicroLabel';
import { euro } from '../format';

/**
 * Chapter 02 — Allocation.
 *
 * One cell per asset category, each closing with a solid block whose height is
 * proportional to that category's share. The backend has already reduced the
 * app's six categories to the design's four cells plus OTHER, so this component
 * renders whatever it is given — the grid column count follows the data rather
 * than assuming four.
 */
function Allocation({ story }) {
  const cells = story?.allocation || [];

  if (cells.length === 0) {
    return (
      <>
        <h2 className="story-h2">Where it all sits.</h2>
        <div className="story-empty">
          <p className="story-empty-text">
            Nothing to split up yet — add your first holding and this page will start
            keeping score.
          </p>
        </div>
      </>
    );
  }

  // The tallest block fills the cell; the rest are measured against it, so a
  // 60/30/10 split reads as three clearly different heights rather than three
  // near-identical ones.
  const maxPct = Math.max(...cells.map((cell) => cell.pct));

  return (
    <>
      <h2 className="story-h2">Where it all sits.</h2>

      {/* Column count travels as a custom property, not an inline
          grid-template-columns — an inline declaration would outrank the
          media query that stacks this grid on narrow screens. */}
      <div className="story-alloc-grid" style={{ '--story-alloc-columns': cells.length }}>
        {cells.map((cell) => (
          <div className="story-alloc-cell" key={cell.category}>
            <MicroLabel>{cell.category}</MicroLabel>

            <div>
              <div className="story-figure story-alloc-pct">{Math.round(cell.pct)}%</div>
              <div className="story-alloc-value">{euro(cell.value)}</div>
            </div>

            <div className="story-alloc-block">
              <div
                className="story-alloc-block-fill"
                style={{ height: `${maxPct > 0 ? (cell.pct / maxPct) * 100 : 0}%` }}
                aria-hidden="true"
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Allocation;
